import { Singleton } from '@denishussar/html5-game-engine';

@Singleton
export class RescueModel {
    public sliderValue: number = 1;
    public running: boolean = false;
    public isShowHintAllowed: boolean = true;
    public isForward: boolean = false;

    constructor() {
    }

    public clear() {
        this.sliderValue = 1;
        this.running = false;
        this.isShowHintAllowed = true;
    }
}
